import React from 'react'
import './TeamScores.scss'

import Shirt from '../components/Shirt'
import oversToBalls from '../util/oversToBalls'

export default function TeamScores({
    teams,
    scoreboard,
    isHundred,
    teamFontSize
}) {
    if (!scoreboard) {
        return 'waiting for scoreboard msg'
    }

    const { 
        currentbattingteam: currentBattingTeam,
        home, 
        away, 
        currentinnings
    } = scoreboard;

    const teamOneName = home;
    const teamTwoName = away;

    let teamOneShortName, teamTwoShortName;

    if (teams) {
        const teamOne = teams.find(t => teamOneName.includes(t.name))
        if (teamOne) {
            teamOneShortName = teamOne.short_name
        }

        const teamTwo = teams.find(t => teamTwoName.includes(t.name))
        if (teamTwo) {
            teamTwoShortName = teamTwo.short_name
        }
    }

    let teamOneRuns = '';
    let teamOneWickets = '';
    let teamOneOvers = 0;

    let teamTwoRuns = '';
    let teamTwoWickets = '';
    let teamTwoOvers = 0;

    // Get runs, wickets and overs for each innings
    for (let i = 1; i <= 4; i++) {
        if (teamOneName === scoreboard[`innings${i}battingteam`]) {
            const runs = scoreboard[`innings${i}runs`]
            if (teamOneRuns !== '') {
                teamOneRuns += ' & ' + runs;
            } else if (runs !== '') {
                teamOneRuns = runs;
            }
            const wickets = scoreboard[`innings${i}wickets`];
            if (wickets !== '') {
                teamOneWickets = wickets;
            }
            teamOneOvers += Number(scoreboard[`innings${i}overs`]);
        }
    }
    for (let i = 1; i <= 4; i++) {
        if (teamTwoName === scoreboard[`innings${i}battingteam`]) {
            const runs = scoreboard[`innings${i}runs`]
            if (teamTwoRuns !== '') {
                teamTwoRuns += ' & ' + runs;
            } else if (runs !== '') {
                teamTwoRuns = runs;
            }
            const wickets = scoreboard[`innings${i}wickets`];
            if (wickets !== '') {
                teamTwoWickets = wickets;
            }
            teamTwoOvers += Number(scoreboard[`innings${i}overs`]);
        }
    }

    let teamOneIcon, teamTwoIcon;
    if (currentBattingTeam === teamOneName) {
        teamOneIcon = <div className="batting-icon"/>;
        teamTwoIcon = null;
    } else if (currentBattingTeam === teamTwoName) {
        teamOneIcon = null;
        teamTwoIcon = <div className="batting-icon"/>;
    }

    let maxOvers = scoreboard[`innings${currentinnings}max`]

    return (
        <div className="team-scores">
            <div className="team" style={{ fontSize: teamFontSize }}>
                <div className="team-name-and-icon">
                    <Shirt primaryColour={teams[0].colour} secondaryColour={teams[0].team_colour}/>
                    <div className="team-name">{teamOneName}</div>
                    <div className="team-short-name">{teamOneShortName}</div>
                    {teamOneIcon}
                </div>
                <div className="team-score-and-overs">
                    <div className="team-score">{ teamOneRuns ? teamOneRuns : 0 }/{ teamOneWickets ? teamOneWickets : 0 }</div>
                    { isHundred ? (
                        <div className="team-overs">
                            {oversToBalls(teamOneOvers)}/100 Balls
                        </div>
                    ) : ( 
                        <div className="team-overs">
                            {teamOneOvers.toFixed(1)} {maxOvers !== 999 && '/' + maxOvers} Ovs
                        </div>
                    )}
                </div>
            </div>
            <div className="team" style={{ fontSize: teamFontSize }}>
                <div className="team-name-and-icon">
                    <Shirt primaryColour={teams[1].colour} secondaryColour={teams[1].team_colour}/>
                    <div className="team-name">{teamTwoName}</div>
                    <div className="team-short-name">{teamTwoShortName}</div>
                    {teamTwoIcon}
                </div>
                <div className="team-score-and-overs">
                    <div className="team-score">{ teamTwoRuns ? teamTwoRuns : 0 }/{ teamTwoWickets ? teamTwoWickets : 0 }</div>
                    { isHundred ? (
                        <div className="team-overs">
                            {oversToBalls(teamTwoOvers)}/100 Balls
                        </div>
                    ) : ( 
                        <div className="team-overs">
                            {teamTwoOvers.toFixed(1)} {maxOvers !== 999 && '/' + maxOvers} Ovs
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
